import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import { useStoreCart, cartCount } from "@/lib/storeCart";
import CartDrawer from "@/components/store/CartDrawer";

// Boton flotante de carrito (lado izquierdo), del mismo tamano que el boton de
// WhatsApp (lado derecho). Comportamiento:
//  - Movil: boton redondo con icono + badge de cantidad.
//  - Escritorio: pastilla con texto "TIENDA" (si vacio -> /tienda) o "CARRITO"
//    (si hay articulos -> abre el sidebar CartDrawer).
export default function FloatingCartButton() {
  const items = useStoreCart();
  const count = cartCount(items);
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  const onClick = () => { if (count > 0) setOpen(true); else nav("/tienda"); };
  const label = count > 0 ? "CARRITO" : "TIENDA";

  return (
    <>
      <button
        onClick={onClick}
        aria-label={count > 0 ? "Ver carrito" : "Ir a la tienda"}
        className="fixed bottom-[calc(7rem+env(safe-area-inset-bottom))] lg:bottom-6 left-4 lg:left-6 z-50 group"
      >
        {/* Movil: boton redondo (mismo tamano que WhatsApp) */}
        <span className="lg:hidden relative w-12 h-12 rounded-full bg-cyan hover:bg-cyan-hover flex items-center justify-center shadow-lg shadow-cyan/40 glow-cyan transition-colors">
          <ShoppingCart className="w-6 h-6 text-ink" />
          {count > 0 && (
            <span className="absolute -top-1 -right-1 bg-ink text-cyan text-[0.65rem] font-bold min-w-5 h-5 px-1 flex items-center justify-center border border-cyan rounded-full">
              {count}
            </span>
          )}
        </span>

        {/* Escritorio: pastilla con texto */}
        <span className="hidden lg:flex items-center gap-2 bg-cyan hover:bg-cyan-hover text-ink px-4 h-12 font-display font-bold uppercase tracking-wide glow-cyan transition-colors">
          <ShoppingCart className="w-5 h-5" />
          <span>{label}</span>
          {count > 0 && (
            <span className="bg-ink text-cyan text-xs px-1.5 min-w-5 h-5 flex items-center justify-center font-bold">
              {count}
            </span>
          )}
        </span>
      </button>
      <CartDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}